import React, { useState, useEffect } from 'react';
import Slider from '../components/Slider';
import client from '../api/client';
import { subDays, format } from 'date-fns';

export default function PeriodStep({ data, update }) {
  const [suggestedCycleDay, setSuggestedCycleDay] = useState(1);

  useEffect(() => {
    const end = format(new Date(), 'yyyy-MM-dd');
    const start = format(subDays(new Date(), 60), 'yyyy-MM-dd');
    client.get(`/checkins?startDate=${start}&endDate=${end}`)
      .then(res => {
        const today = format(new Date(), 'yyyy-MM-dd');
        const periodCheckIns = res.data
          .filter(c => c.isPeriodDay && c.checkInDate !== today && c.cycleDay)
          .sort((a, b) => b.checkInDate.localeCompare(a.checkInDate));

        if (periodCheckIns.length > 0) {
          const last = periodCheckIns[0];
          const lastDate = new Date(last.checkInDate);
          const todayDate = new Date(today);
          const daysDiff = Math.round((todayDate - lastDate) / (1000 * 60 * 60 * 24));

          if (daysDiff <= 7) {
            setSuggestedCycleDay(last.cycleDay + daysDiff);
          }
        }
      })
      .catch(() => {});
  }, []);

  const handlePeriodOn = () => {
    update({
      isPeriodDay: true,
      cycleDay: suggestedCycleDay,
      periodFlow: data.periodFlow || 1,
      crampIntensity: data.crampIntensity || 1,
      energyLevel: data.energyLevel || 1,
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4 mb-4">
        <label className="text-sm font-medium text-white/80">Period today?</label>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => update({
              isPeriodDay: false,
              cycleDay: null,
              periodFlow: null,
              crampIntensity: null,
              energyLevel: null,
            })}
            className={`px-4 py-1.5 rounded-lg text-sm font-medium transition
              ${data.isPeriodDay === false
                ? 'bg-white/20 text-white ring-2 ring-white/30'
                : 'bg-white/10 text-white/60 hover:bg-white/20'
              }`}
          >
            No
          </button>
          <button
            type="button"
            onClick={handlePeriodOn}
            className={`px-4 py-1.5 rounded-lg text-sm font-medium transition
              ${data.isPeriodDay === true
                ? 'bg-white/20 text-white ring-2 ring-white/30'
                : 'bg-white/10 text-white/60 hover:bg-white/20'
              }`}
          >
            Yes
          </button>
        </div>
      </div>

      {data.isPeriodDay && (
        <div className="space-y-5 pl-1">
          <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-white/80">Cycle Day</label>
            <input
              type="number"
              min="1"
              max="60"
              value={data.cycleDay || ''}
              onChange={(e) => update({ cycleDay: e.target.value ? parseInt(e.target.value) : null })}
              className="w-16 rounded-lg bg-white/10 border-white/20 text-white shadow-sm focus:border-white/40 focus:ring-white/30 text-center"
            />
            <span className="text-xs text-white/40">(auto-calculated)</span>
          </div>

          <Slider
            label="Flow"
            value={data.periodFlow}
            onChange={(v) => update({ periodFlow: v })}
            lowLabel="Light"
            highLabel="Heavy"
          />

          <Slider
            label="Cramp Intensity"
            value={data.crampIntensity}
            onChange={(v) => update({ crampIntensity: v })}
            lowLabel="None"
            highLabel="Severe"
          />

          <Slider
            label="Energy Level"
            value={data.energyLevel}
            onChange={(v) => update({ energyLevel: v })}
            lowLabel="Drained"
            highLabel="Energized"
          />
        </div>
      )}
    </div>
  );
}
